import { Slider } from 'antd'
import { SliderRangeProps } from 'antd/es/slider'
function RangeSelector({...props}:SliderRangeProps) {
  return (
    <Slider  {...props}  />
  )
}

export default RangeSelector